export default "__VITE_ASSET__DE$rFlhj__"